import { get } from "svelte/store";
import { push, location } from "svelte-spa-router";
import { UserState, userState } from "./store";


interface GraphNode<TState> {
    path: string;
    canAdvance: (state: TState) => boolean;
    canRewind: (state: TState) => boolean;
}
interface Graph<TState> {
    node: GraphNode<TState>,
    previous?: Graph<TState>,
    next?: Graph<TState>,
    end?: 'first' | 'last';
}
export class UserProcessNavigator {
    private currentUserState: UserState = get(userState);
    private currentRoutedLocation: string;
    private loginNode = <GraphNode<UserState>>{
        path: '/myanalysis/login',
        canAdvance: (s) => s.isLoggedIn,
        canRewind: (s) => false,
    }
    private userDetailsNode = <GraphNode<UserState>>{
        path: '/myanalysis/userdetails',
        canAdvance: (s) => s.userDetailsConfirmed,
        canRewind: (s) => false
    }
    private hipaaNode = <GraphNode<UserState>>{
        path: '/myanalysis/hipaa',
        canAdvance: (s) => s.isHipaaSigned,
        canRewind: (s) => true
    }
    private resultsNode = <GraphNode<UserState>>{
        path: '/myanalysis/assessmentresults',
        canAdvance: (s) => false,
        canRewind: (s) => true
    }

    private confirmationNode = <GraphNode<UserState>>{
        path: '/myanalysis/userdetails/confirm',
        canAdvance: (s) => false,
        canRewind: (s) => true
    }

    private navGraph: Graph<UserState>;
    private currentGraph: Graph<UserState>;
    constructor() {

        location.subscribe(s => {
            this.currentRoutedLocation = s;
        });
        this.navGraph = this.buildNavGraph(this.currentUserState);
        this.currentGraph = this.navGraph;
        userState.subscribe(s => this.navGraph = this.buildNavGraph(s));
    }

    private buildNavGraph(state: UserState): Graph<UserState> {

        //if ((state.assessment) && (state.assessment.riskScore)) {
        if(false) {
                return <Graph<UserState>>{
                node: this.loginNode,
                end: 'first',
                next: {
                    node: (state.isBasicMode) ? this.confirmationNode : this.resultsNode,
                    previous: {
                        node: this.loginNode
                    }
                }
            };
        }
        else {
            return <Graph<UserState>>{
                node: this.loginNode,
                end: 'first',
                next: {
                    node: this.userDetailsNode,
                    next: {
                        node: this.hipaaNode,
                        next: {
                            node: (state.isBasicMode) ? this.confirmationNode : this.resultsNode,
                            previous: {
                                node: this.hipaaNode
                            }
                        },
                        previous: {
                            node: this.userDetailsNode,
                            end: 'last'
                        }
                    }
                }
            };
        }
    }

    next(): void {
        if (this.currentGraph.node.canAdvance(this.currentUserState)) {
            this.currentGraph = this.currentGraph.next;
            this.navigateToCurrentNode();
        }
    }
    previous(): void {
        if (this.currentGraph.node.canRewind(this.currentUserState)) {
            this.currentGraph = this.currentGraph.previous
            this.navigateToCurrentNode();
        }
    }
    navigateToDefaultForCurrentState(): void {
        let current = this.navGraph;
        while (current?.node?.canAdvance(this.currentUserState)) {
            current = current.next;
        }
        if (this?.currentGraph !== current || current.node.path !== this.currentRoutedLocation) {
            this.currentGraph = current;
            this.navigateToCurrentNode();
        }
    }
    private navigateToCurrentNode() {
        push(this.currentGraph.node.path);
    }

}